const ReviewsConstants: { [key: string]: { [key: string]: string } } = {
  RESPONSE_STATUS: {
    OK: 'OK',
    PENDING: 'PENDING',
    DELETED: 'DELETED',
    REJECTED: 'REJECTED',
  },
  REPORT_REVIEW_STATUS: {
    PENDING: 'PENDING',
    REVIEWED: 'REVIEWED',
  },
  REVIEW_TYPES: {
    PROPERTY: 'property',
    PROPERTY_MANAGER: 'propertyManager',
    AREA: 'area',
  },
  REVIEW_TYPES_LABEL: {
    property: 'Property',
    propertyManager: 'Management',
  },
  REPORT_REVIEW_REASONS: {
    INAPPROPRIATE: 'inappropriate',
    INACCURATE: 'inaccurate',
    OTHER: 'other',
  },
  REPORT_REVIEW_REASONS_LABEL: {
    INAPPROPRIATE: 'Inappropriate language',
    INACCURATE: 'Incorrect information / Wrong listing',
    OTHER: 'Other',
  },
  REVIEW_STATUS: {
    OK: 'ok',
    OK_STARS_ONLY: 'okStarsOnly',
  },
};

export default ReviewsConstants;
